import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { SearchResultComponent } from '@softapps/core';
import { I18nModule } from '@softline/ui-core';
import { KtostammKundeSubnummerListView } from '../list-view/ktostamm-kunde-subnummer.list-view';

@Component({
  selector: 'soft-field-ok-ktostamm-kunde-subnummer-search-result-view',
  imports: [I18nModule, KtostammKundeSubnummerListView],
  templateUrl: './search-result-view.component.html',
  styleUrl: './search-result-view.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KtostammKundeSubnummerFieldOkSearchResultViewComponent
  implements SearchResultComponent<any>
{
  readonly result = input.required<any>();
}
